import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, switchMap } from 'rxjs';
import { PlatformAPIClientAuthorizationService } from '@services/platform-api-client-authorization.service';

export const KeplerSlapfiveInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const urlToMatch = environment.api.kepler.slapfive.url;
  const authService = inject(PlatformAPIClientAuthorizationService);

  if (urlToMatch && request.url.startsWith(urlToMatch)) {
    return authService.getAccessToken().pipe(
      switchMap((token: string) => {
        const region = authService.getSelectedRegion();
        const clonedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'csdt-authorization-app': 'welcomevideo',
            'Content-Type': 'application/json',
            'X-api-key': environment.api.kepler.slapfive.apiKey,
            ...(region?.env && { 'csdt-gc-api-url': region.env }),
          },
        });
        console.debug('Kepler Slapfive interceptor (authenticated user)', clonedRequest);
        return next(clonedRequest);
      }),
    );
  } else {
    return next(request);
  }
};
